import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import ExampleTable from '../views/ExampleTable.vue'
import ReportPage from '../views/ReportPage.vue'
import LoginPage from '../views/LoginPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: LoginPage, name: 'LoginPage' },
  { path: '/home', component: HomePage, name: 'HomePage' },
  { path: '/table', component: ExampleTable, name: 'ExampleTable' },
  { path: '/report', component: ReportPage, name: 'ReportPage' },
  { 
    path: '/new', 
    name: 'new',
    // component: () => import(/* webpackChunkName: "about" */ "@/views/dictionaries/customer/newindex.vue")
  },

  // 系统管理相关路由
  {
    path: "/system/admin",
    name: "system_admin",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/users/index.vue")
  },
  {
    path: "/system/menu",
    name: "menu",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/menu/index.vue")
  },
  {
    path: "/system/permission",
    name: "permission",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/permission/index.vue")
  },
  {
    path: "/system/role",
    name: "role",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/role/index.vue")
  },
  {
    path: "/system/tag",
    name: "tag",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/tag/index.vue")
  },
  {
    path: "/system/group",
    name: "group",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/group/index.vue")
  },
  {
    path: "/device/list",
    name: "device_management",
    component: () => import(/* webpackChunkName: "about" */ "@/views/device/index.vue")
  },

  //商铺管理
  {
    path: "/temple",
    name: "temple",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/place/temple/index.vue"),
    children: [],
  },
  {
    path: "/temple/hall",
    name: "scene",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/place/scene/index.vue"),
    children: [],
  },
  {
    path: "/user",
    name: "user_list",
    component: () => import(/* webpackChunkName: "about" */ "../views/components/userList.vue")
  },
  {
    path: "/place_user",
    name: "place_user_list",
    component: () => import(/* webpackChunkName: "about" */ "../views/components/placeUserList.vue")
  },
  {
    path: "/order",
    name: "order",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/order/orderList/index.vue"),
  },
  {
    path: "/work/otherBless",
    name: "bless",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/work/otherBless/index.vue"),
  },
 
  {
    path: "/mine",
    name: "mine",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/mine/index.vue"),
  },
  {
    path: "/message",
    name: "message",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/mine/message.vue"),
  },
  {
    path: "/custom/list",
    name: "customer",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/customer/index.vue"),
  },
  {
    path: "/qrcode",
    name: "qrcode",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/mine/qrcode.vue"),
  },
  {
    path: "/dictionaries/hall",
    name: "hall_dictionaries",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/dictionaries/hall/index.vue"),
  },
  {
    path: "/dictionaries/subscribe",
    name: "subscribe_list",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/dictionaries/subscribe/index.vue"),
  },
  {
    path: "/dictionaries/customer",
    name: "customer_tag_list",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/dictionaries/customer/index.vue"),
  },
  {
    path: "/calendar",
    name: "calendar",
    component: () =>
        import(/* webpackChunkName: "about" */ "@/views/calendar/index.vue"),
  },
  {
    path: "/library",
    name: "library",
    component: () =>
        import(/* webpackChunkName: "about" */ "@/views/library/index.vue"),
  },
  {
    path: "/tool/list",
    name: "tool_manager",
    component: () =>
        import(/* webpackChunkName: "about" */ "@/views/tool/index.vue"),
  }
]

const router = new VueRouter({
  routes
})

export default router
